import { useEffect, useMemo } from 'react'
import { Timeline } from '../core/Timeline'
import { Context } from '../core/Context';

export function useTimeline(id?: string, ctx?: Context) {
    const tl = useMemo(() => new Timeline([], id), [id])

    useEffect(() => {
        if (ctx) ctx.add(tl)
        
        return () => 
        {
            tl.kill()
            ctx?.delete(tl)
        }
    }, [tl, ctx]) 

    return tl; 
}
